<template>
  <div class="gallery">
    <div v-for="(src, i) in srcList" :key="i">
      <el-image
        v-show="i === 0"
        :src="src"
        :initial-index="i"
        :preview-src-list="srcList"
        fit="contain"
      ></el-image>
    </div>
    <div v-if="srcList.length > 1" class="tag">
      <span>共{{ srcList.length }}张</span>
    </div>
    <div v-else-if="srcList.length < 1">
      <span>-</span>
    </div>
  </div>
</template>

<script>
import baseConfig from "../../utils/serverUrlConfig";

export default {
  name: "Gallery",
  props: ["list"],
  computed: {
    srcList() {
      const list = (Array.isArray(this.list) ? this.list : [this.list]).filter(
        (v) => !!v
      );
      return list.map((v) => baseConfig.imgUrl + v);
    },
  },
  data() {
    return {
      index: 0,
      timer: null,
    };
  },
  mounted() {
    // this.timer = setInterval(() => {
    //   const count = this.srcList.length
    //   if (count < 2) return
    //   this.index = (this.index + 1) % count
    // }, 2000);
  },
  activated() {},
  deactivated() {},
};
</script>

<style lang="scss" scoped>
.gallery {
  position: relative;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;

  .tag {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0px 8px;
    background-color: #0009;
    font-size: 10px;
    line-height: 16px;
    border-radius: 100px;
    color: #fff;
  }

  .el-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
